import { render } from "./Preview.vue?vue&type=template&id=a20a032e"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=a20a032e&lang=css"
script.render = render

export default script